/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityAssetIpAddressesHosting
 */
export interface MonitEntityAssetIpAddressesHosting {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetIpAddressesHosting
     */
    service?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetIpAddressesHosting
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetIpAddressesHosting
     */
    source_list_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetIpAddressesHosting
     */
    subcategory?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetIpAddressesHosting
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetIpAddressesHosting
     */
    last_found?: number;
}

/**
 * Check if a given object implements the MonitEntityAssetIpAddressesHosting interface.
 */
export function instanceOfMonitEntityAssetIpAddressesHosting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityAssetIpAddressesHostingFromJSON(json: any): MonitEntityAssetIpAddressesHosting {
    return MonitEntityAssetIpAddressesHostingFromJSONTyped(json, false);
}

export function MonitEntityAssetIpAddressesHostingFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetIpAddressesHosting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'service': !exists(json, 'service') ? undefined : json['service'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'source_list_name': !exists(json, 'source_list_name') ? undefined : json['source_list_name'],
        'subcategory': !exists(json, 'subcategory') ? undefined : json['subcategory'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'last_found': !exists(json, 'last_found') ? undefined : json['last_found'],
    };
}

export function MonitEntityAssetIpAddressesHostingToJSON(value?: MonitEntityAssetIpAddressesHosting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'service': value.service,
        'region': value.region,
        'source_list_name': value.source_list_name,
        'subcategory': value.subcategory,
        'created': value.created,
        'last_found': value.last_found,
    };
}

